export const FIRM = {
  name: "Shelton Law",
  longName: "Shelton Law PLLC",
  attorney: "Jack Shelton",

  // Primary firm inbox — Home, Contact, Footer, Header
  email: "info@shelton.law",
  emailHref: "mailto:info@shelton.law",

  // Recruiting inbox — Careers, Home careers hook, Footer
  careersEmail: "careers@shelton.law",
  careersEmailHref: "mailto:careers@shelton.law",

  // Direct-to-founder inbox — About, People (Jack's card)
  jackEmail: "jack@shelton.law",
  jackEmailHref: "mailto:jack@shelton.law",

  hours: "Monday–Friday, 9:00 AM – 5:00 PM CT",
  founded: 2008,
};
